import { memo } from "react";
import { useTypedSelector } from "hooks";
import { route, when } from "util/support";
import { isFormChanged } from "util/forms";
import type { BankingSdkConnector } from "features/openBanking/types";
import { selectConstants, selectConnectorsFlowsOptions, selectIsConstantsLoading } from "features/general/selectors";
import { useBankingSDKActions } from "features/openBanking/actions";
import ActionPanel from "ui/molecules/ActionPanel";
import { useResourceContext } from "ui/widgets/Resource";
import { TabLayout } from "ui/widgets/StatefulTabs";
import { BankingSDK } from 'ui/forms/OpenBanking'

const EditBankingSDKResourceForm = () => {
    const isConstantsLoading = useTypedSelector(selectIsConstantsLoading);
    const constants = useTypedSelector(selectConstants);

    const { updateBankingSdkConnector } = useBankingSDKActions();

    const { resource, onClose } = useResourceContext<BankingSdkConnector>();

    const formBootstrapData = {
        OpenBankingLogosDomain: constants.OpenBankingLogosDomain,
        ConnectorsFlows: useTypedSelector(selectConnectorsFlowsOptions)
    };

    const formProps: BankingSDK.BankingSDKForm = {
        bootstrapData: formBootstrapData,
        initialValues: BankingSDK.getInitialValues(resource, formBootstrapData),
        isBootstrapDataLoading: (
            isConstantsLoading
        ),
        onSaveOrCreate: async ({
            aisOptions,
            pisOptions,
            countryISO,
            fullName,
            bankGroup,
            bankId,
            status,
            flow,
            logoUrl,
            ...values
        }) => {
            const logo = logoUrl?.trim();
            const [request, result] = updateBankingSdkConnector({
                ...values,
                logoUrl: when(
                    logo,
                    route([logo]),
                    null
                ),
                // aisOptions: JSON.stringify(aisOptions),
                // pisOptions: JSON.stringify(pisOptions),
                // countryISO: countryISO!.at(0),
                flow: when(flow, () => flow!.id, flow)
            });

            await request;
            onClose();

            return result;
        }
    };

    const form = BankingSDK.useForm(formProps);

    return (
        <TabLayout>
            <BankingSDK.Form
                {...form}
                {...formProps}
            >
                <ActionPanel
                    isLoading={form.isSubmitting}
                    onSave={async () => { }}
                    onCancel={onClose}
                    SaveActionProps={{
                        type: 'submit',
                        disabled: !form.isValid || !isFormChanged(form),
                        loading: form.isSubmitting
                    }}
                />
            </BankingSDK.Form>
        </TabLayout>
    );
};

export default memo(EditBankingSDKResourceForm);
